<header>
  <nav class="bg-primary w-[-webkit-fill-available] rounded-xl shadow-card-elevated">
    <div class="px-4">
      <div class="flex justify-between items-center transition-[height] duration-200" [ngClass]="scrolled ? 'h-14' : 'h-16'">
        <!-- Logo -->
        <a routerLink="/" class="flex-shrink-0 rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent">
          <img ngSrc="assets/images/logo_transparent_rectangle.png" alt="corpers.ng logo" class="w-28 -mb-1" width="410" height="65" priority>
        </a>
        <!-- Desktop Menu -->
        <div class="hidden md:flex gap-1 text-white font-medium">
          <a routerLink="/about"
            class="px-3 py-2 rounded-lg hover:text-accent hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent transition-colors duration-200">About</a>
          <!-- On the home page Services only scrolls; elsewhere it goes to the home page's section -->
          <a *ngIf="onHomePage; else servicesElsewhere" [href]="pagePath + '#services'"
            class="px-3 py-2 rounded-lg hover:text-accent hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent transition-colors duration-200">Services</a>
          <ng-template #servicesElsewhere>
            <a routerLink="/" fragment="services"
              class="px-3 py-2 rounded-lg hover:text-accent hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent transition-colors duration-200">Services</a>
          </ng-template>
          <a [href]="pagePath + '#contact'"
            class="px-3 py-2 rounded-lg hover:text-accent hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent transition-colors duration-200">Contact</a>
          <a routerLink="/login"
            class="px-3 py-2 rounded-lg hover:text-accent hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent transition-colors duration-200">Login</a>
        </div>

        <!-- Desktop Button -->
        <div class="hidden md:block">
          <a routerLink="/signup" class="btn-accent focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent">
            Sign up
          </a>
        </div>

        <!-- Mobile Menu Button -->
        <div class="md:hidden -mr-2">
          <button #menuButton type="button" (click)="toggleMobileMenu()"
            class="flex items-center justify-center size-12 rounded-lg text-white hover:bg-white/10 active:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent transition-colors duration-200"
            [attr.aria-expanded]="isMobileMenuOpen" aria-controls="mobile-menu"
            [attr.aria-label]="isMobileMenuOpen ? 'Close menu' : 'Open menu'">
            <mat-icon class="!size-7 !text-[28px]">{{ isMobileMenuOpen ? 'close' : 'menu' }}</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- Mobile Menu: every row and button is at least 48px tall, so it's easy to hit with a thumb -->
    <div id="mobile-menu" class="md:hidden px-2 pb-4 text-white font-medium"
      [ngClass]="{ hidden: !isMobileMenuOpen }">
      <div class="border-t border-white/10 pt-2">
        <a routerLink="/about" (click)="closeMobileMenu()"
          class="flex items-center justify-between min-h-12 px-2 rounded-lg text-base hover:bg-white/10 active:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent transition-colors duration-200">
          About <mat-icon class="text-white/50">chevron_right</mat-icon>
        </a>
        <a *ngIf="onHomePage; else mobileServicesElsewhere" [href]="pagePath + '#services'" (click)="closeMobileMenu()"
          class="flex items-center justify-between min-h-12 px-2 rounded-lg text-base hover:bg-white/10 active:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent transition-colors duration-200">
          Services <mat-icon class="text-white/50">chevron_right</mat-icon>
        </a>
        <ng-template #mobileServicesElsewhere>
          <a routerLink="/" fragment="services" (click)="closeMobileMenu()"
            class="flex items-center justify-between min-h-12 px-2 rounded-lg text-base hover:bg-white/10 active:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent transition-colors duration-200">
            Services <mat-icon class="text-white/50">chevron_right</mat-icon>
          </a>
        </ng-template>
        <a [href]="pagePath + '#contact'" (click)="closeMobileMenu()"
          class="flex items-center justify-between min-h-12 px-2 rounded-lg text-base hover:bg-white/10 active:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent transition-colors duration-200">
          Contact <mat-icon class="text-white/50">chevron_right</mat-icon>
        </a>
      </div>
      <div class="grid grid-cols-2 gap-3 px-2 pt-4 mt-2 border-t border-white/10">
        <a routerLink="/login"
          class="flex items-center justify-center min-h-12 rounded-lg border-2 border-white/40 hover:bg-white/10 active:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent transition-colors duration-200">
          Login
        </a>
        <a routerLink="/signup" class="btn-accent flex items-center justify-center min-h-12 !py-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent">
          Sign up
        </a>
      </div>
    </div>
  </nav>
</header>
